export default __webpack_public_path__ + "static/media/Jackets.367fe990.JPG";